import { AxiosResponse } from 'axios';
import environment from '@environment';
import { EndpointHelper } from 'core/services/endpoint.helper';
import { HttpClient } from 'core/services/http';
import { MomentGetPaymentStatusResponse, MomentMakePaymentRequest, MomentMakePaymentResponse } from 'core/stores/payment/interfaces/moment-make-payment';
import { PaymentService } from 'core/stores/payment/interfaces/payment-service';
import { PayAtTokenizeResponse } from './payment-pay-at';

export class MomentService implements PaymentService<MomentMakePaymentRequest> {
  public canStatusPoll = true;
  public canRefetchPoll = false;
  public canTimeoutPoll = true;

  private apiBuilder = new EndpointHelper(`${environment.UNI_API_URI}/${environment.MAH_API_PAYMENT_PROCESSOR}/api/pso/v1/paymentsession`);
  private utilityApiBuilder = new EndpointHelper(`${environment.UTILITY_API_URI}`);

  MakePayment(req?: Partial<any>) {
    if (!req) {
      return Promise.reject('')
    }
    const url = this.apiBuilder.createUrl('create')
      .build();

    return HttpClient.GetInstance
      .post<MomentMakePaymentRequest, MomentMakePaymentResponse>(
        url, req as MomentMakePaymentRequest
      )
      .then(
        (res: AxiosResponse<MomentMakePaymentResponse>) => {
          const response = res?.data;

          return {
            redirectUrl: response.sessionUrl,
            transactionId: response.transactionId,
            deTransactionRef: response.deTransactionRef,
            deReferenceId: response.deReferenceId,
            paymentType: `${req.paymentActionType}`
          }
        }
      );
  }

  PaymentStatus(country: string, customerNumber: string, transactionId: string): Promise<MomentGetPaymentStatusResponse> {
    const url = this.apiBuilder.createUrl('status')
      .addRouteParam(transactionId)
      .addQueryParam('customerNumber', customerNumber)
      .build();

    return HttpClient.GetInstance.get<MomentGetPaymentStatusResponse>(url).then((res: AxiosResponse<MomentGetPaymentStatusResponse>) => res.data);
  }

  TokenLinks(requestBody?: any) {
    const url = this.utilityApiBuilder.createUrl('paymentLink')
      .addBaseRouteParam('payat', 'token')
      .build();

    return HttpClient.GetInstance.post<unknown, PayAtTokenizeResponse>(url, requestBody)
      .then(
        (res) => {
          const response = res?.data;
          return {
            redirectUrl: response.tokenPaymentUrl,
            transactionId: response.referenceKey,
            paymentType: `${response.responseCode}`
          }
        },
        err => {
          console.error('Failed request', err);
          return Promise.reject(err);
        });
  }

  RefetchPayment() {
    return Promise.reject('MomentService -> RefetchPayment Not Implemented')
  }
}